module.exports = __webpack_public_path__ + "static/media/activedashboardicon.9d695847.svg";